export class CandidateDisplayQueryFilter {
    searchString = '';
    clientOrBuList: any[] = [];
    status: any[] = [];
    requisitionStatus: any[] = [];
    requisitionNumbers: any[] = [];
    firstName = '';
    lastName = '';
    phone = '';
    email = '';
    workflowStates: any[] = [];
    recruiterList: any[] = [];
    roleList: any[] = [];
    workLocationIds: any[] = [];
    sponsorships: any[] = [];
    jobTypes: any[] = [];
    jobSubTypes: any[] = [];
    salary: any = '';
    rate: any = '';
    visibility: any[] = [];
    vendors: any[] = [];
    selectedFilterSort = '';
    showCandidateDisplayFilterIcon = true;
}
